import { render, staticRenderFns } from "./TelemedicineAppointmentTable.vue?vue&type=template&id=177be93e&"
import script from "./TelemedicineAppointmentTable.vue?vue&type=script&lang=js&"
export * from "./TelemedicineAppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports